import { withPayloadType } from 'utils';
import { createAction } from '@reduxjs/toolkit';

export const showSectionStart = createAction(
  'SHOW_SECTIONS::START',
  withPayloadType<{ sectionId: string }>(),
);
